/* eslint-disable max-len */
import { CompletedStep, PendingStep } from './entities';
import StepCollection from './StepCollection';
import {
  InvalidSteps,
  NextStepNotFound,
  NoMorePendingActivities,
  NoNextSteps,
  NoPreviousSteps,
  PreviousStepNotFound,
  StepNotFound,
  StepProcessorError
} from './errors';

// TODO: This is an abstract class for limitedAccount and unlimitedAccount
class EnrollmentStepProcessor {
  constructor(completedActivities) {
    this._steps = new StepCollection(this.getSteps(completedActivities));

    if (!this._areValidSteps(completedActivities)) {
      throw new InvalidSteps();
    }

    this._completedActivities = completedActivities;
    this._pendingActivities = this._buildPendingActivities(completedActivities);
  }

  getFirstPendingActivity() {
    try {
      const firstPendingStep = this._steps.find(this._pendingActivities[0]);

      return new PendingStep(firstPendingStep);
    } catch (error) {
      if (error instanceof StepNotFound) {
        throw new NoMorePendingActivities(error);
      }

      throw new StepProcessorError(error);
    }
  }

  getNextStep(stepName) {
    let nextStep;
    try {
      nextStep = this._steps.findNext(stepName);
    } catch (error) {
      if (error instanceof NextStepNotFound) {
        throw new NoNextSteps();
      }

      throw new StepProcessorError(error);
    }

    if (this._isCompleted(nextStep.name)) {
      return new CompletedStep(nextStep);
    }

    return new PendingStep(nextStep);
  }

  getPreviousStep(stepName) {
    let previousStep;

    try {
      previousStep = this._steps.findPrevious(stepName);
    } catch (error) {
      if (error instanceof PreviousStepNotFound) {
        throw new NoPreviousSteps(error);
      }

      throw new StepProcessorError(error);
    }

    if (this._isCompleted(previousStep.name)) {
      return new CompletedStep(previousStep);
    }

    return new PendingStep(previousStep);
  }

  // TODO: make tests for this
  isEnabledURL(url) {
    const activity = this._getActivityByURL(url);

    if (this._completedActivities.includes(activity) || this._pendingActivities[0] === activity) {
      return true;
    }

    return false;
  }

  // TODO: make tests for this
  getActivityBy(url) {
    return this._getActivityByURL(url);
  }

  _buildPendingActivities(completedActivities) {
    const pendingActivities = [];
    const stepsNames = this._steps.getOrderedByName();

    stepsNames.forEach(stepName => {
      if (!completedActivities.includes(stepName)) {
        pendingActivities.push(stepName);
      }
    });

    return pendingActivities;
  }

  _isCompleted(stepName) {
    return this._completedActivities.includes(stepName);
  }

  _areValidSteps(completedActivities) {
    let isStepsValid = true;
    let updatedActivities = completedActivities;

    if (updatedActivities.includes('upload_address_proof')) {
      updatedActivities = updatedActivities.filter(activity => activity !== 'upload_address_proof');
    }

    updatedActivities.forEach(activity => {
      try {
        this._steps.find(activity);
      } catch (error) {
        isStepsValid = false;
      }
    });

    return isStepsValid;
  }

  _getActivityByURL(url) {
    let activity = '';
    const stepsNames = this._steps.getOrderedByName();

    stepsNames.forEach(stepName => {
      const step = this._steps.find(stepName);

      if (step.completedURL === url || step.pendingURL === url) {
        activity = step.name;
      }
    });

    return activity;
  }
}

export default EnrollmentStepProcessor;
